<template>
  <div id="contact-form">
    <b-alert
      variant="success"
      v-if="!show"
      show
    >Dziękujemy, wiadomość została przekazana do naszego zespołu.</b-alert>
    <b-alert variant="danger" v-if="errors" show>Wystąpiły błędy w treści formularza:
      <ul>
        <li v-for="(err, index) in errors" :key="index">
          {{ err[0] }}
        </li>
      </ul>
    </b-alert>
    <b-form v-if="show" @submit="sendMail" id="web-contact">
      <b-form-input
        id="input-name"
        v-model="form.name"
        type="text"
        required
        placeholder="Imię i nazwisko (nazwa)*"
        class="ksps-form-field"
      ></b-form-input>
      <b-form-input
        id="input-email"
        v-model="form.email"
        type="email"
        required
        placeholder="Adres e-mail*"
        class="ksps-form-field"
      ></b-form-input>
      <b-form-input
        id="input-phone"
        v-model="form.phone"
        type="phone"
        placeholder="Numer telefonu"
        class="ksps-form-field"
      ></b-form-input>
      <b-form-input
        id="input-topic"
        v-model="form.subject"
        type="text"
        required
        placeholder="Temat*"
        class="ksps-form-field"
      ></b-form-input>
      <b-form-textarea
        id="input-content"
        v-model="form.message"
        placeholder="Treść wiadomości*"
        class="ksps-form-field"
        rows="6"
      ></b-form-textarea>
      <div class="ksps-file-attach">
        <b-form-file
          accept="image/*, document/*"
          v-model="form.file"
          ref="file-input"
          class="ksps-file-button"
          browse-text="Dołącz plik"
          placeholder
        ></b-form-file>
      </div>
      <p class="agreement">
        Oświadczam, iż zapoznałam/-łem się z <b-link class="underline-link" :to="{name: 'Polityka ochrony danych osobowych'}">Polityką ochrony danych osobowych</b-link> obowiązującą w STAWIARSKA STALA Kancelaria Radców Prawnych spółka cywilna z siedzibą w Krakowie.
      </p>
      <p class="agreement">
        Administratorem danych osobowych jest STAWIARSKA STALA Kancelaria Radców Prawnych spółka cywilna z siedzibą w Krakowie, ul. Szlak 77/222, 31 – 153 Kraków. Państwa dane osobowe będą przetwarzane w celu odpowiedzi na Państwa pytanie. Podanie danych osobowych jest dobrowolne, jednakże odmowa podania danych osobowych uniemożliwia udzielenie odpowiedzi na zadane pytanie.</p>
      <div class="text-center">
        <spinner :animation-duration="1000" :size="30" color="#292a2b" v-if="spinner" class="spinner mr-5" />
        <b-button type="submit" class="ksps-form-field ksps-form-submit">Wyślij</b-button>
      </div>
    </b-form>
  </div>
</template>
<style scoped>
.spinner {
  position:relative;
  padding:1rem;
  display:inline-block;
}
</style>
<style>
.ksps-form-field {
  font-size: 1.4rem;
  text-transform: uppercase !important;
  border: 1px solid #292a2b;
  border-radius: 0;
  margin: 1.5rem 0;
  -webkit-box-shadow: 3px 3px 5px -1px rgba(41, 42, 43, 0.35);
  -moz-box-shadow: 3px 3px 5px -1px rgba(41, 42, 43, 0.35);
  box-shadow: 3px 3px 5px -1px rgba(41, 42, 43, 0.35);
  padding: 2rem;
}
.agreement {
  font-size: 1rem;
  font-style: oblique;
  color: #8e8e8e;
}
.ksps-form-submit {
  color: #fff;
  background: #202a2b;
  margin: 1rem auto;
  padding: 1rem 3rem;
  border-radius: 0.3rem;
}
.ksps-file-button {
  background: none !important;
  cursor: pointer;
}
.ksps-file-attach .custom-file-label {
  background: transparent;
  border: 0;
  padding-left: 12rem;
  margin: 0;
  height: auto;
  cursor: pointer;
}
.ksps-file-attach .custom-file-label::after {
  left: 0;
  width: 10rem;
  background: inherit;
  border-bottom: 1px solid #202a2b;
  text-align: left;
  padding: 0;
  margin: 0;
  height: 2.8rem;
  cursor: pointer;
}
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      show: true,
      errors: null,
      spinner: false,
      form: {
        email: "",
        name: "",
        phone: "",
        subject: "",
        message: "",
        file: null
      },
    };
  },
  methods: {
    async sendMail(evt) {
      evt.preventDefault();
      const formData = new FormData()
      formData.append('subject', this.form.subject)
      formData.append('message', this.form.message)
      formData.append('name', this.form.name)
      formData.append('email', this.form.email)
      if (this.form.phone.length > 0) {
              formData.append('phone', this.form.phone)
      }
      if (this.form.file) {
        formData.append('attachment', this.form.file)
      }
      this.spinner = true;
      await axios
        .post(this.$store.state.apiUrl + "contact", formData, {headers: {
            'Content-Type': 'multipart/form-data'
        }})
        .then(response => {
          //console.log(response);
          this.errors = null;
          this.show = false;
        })
        .catch(error => {
          //console.log(error.response);
          this.errors = error.response.data;
        });
        this.spinner = false;
    }
  }
};
</script>